export default __webpack_public_path__ + "static/media/phantom.a62df4d6.svg";